export const manifest = {
  screens: {
    scr_4jvgy8: { name: "Home", route: "/" },
  },
}
